import React from 'react'

const Jobs = () => {
  return (
    <div className="globalmainstyles">
      Jobs
    </div>
  )
}

export default Jobs
